import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function PhoneSMS({ color = 'icon.primary', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 24 24' {...props}>
      <Path
        d='M18.4142 3.58579C19.1953 4.36684 19.1953 5.63317 18.4142 6.41422C17.6332
         7.19527 16.3668 7.19527 15.5858 6.41422C14.8047 5.63317 14.8047 4.36684
          15.5858 3.58579C16.3668 2.80474 17.6332 2.80474 18.4142 3.58579'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M10.8599 18.5H13.1099'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='transparent'
      />
      <Path
        d='M16.9995 9.99731V18.9973C16.9995 20.1023 16.1045 20.9973 14.9995 20.9973H8.99951C7.89451 20.9973
         6.99951 20.1023 6.99951 18.9973V6.99731C6.99951 5.89231 7.89451 4.99731 8.99951 4.99731H11.9995'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='transparent'
      />
    </IconBase>
  )
}

export default PhoneSMS

PhoneSMS.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}
